<template>
    <v-card>
      <!-- <v-card-text class="red darken-1 chartwrapper"> -->
      <v-card-text>
          <!-- <barchart v-if="chartdata" :chart-data="chartdata" :options="chartoptions" style="height: 150px" class="red darken-1"></barchart> -->
          <v-layout>
            <v-flex>
              <barchart :chart-data="chartdata" :options="chartoptions" style="height: 150px" class="red darken-1"></barchart>
            </v-flex>
          </v-layout>
          <div class="mt-3 ml-2 grey--text">
            <p class="title">Call distribution</p>
            <p class="body-1 mb-0">Average <span class="green--text">{{ calls_per_hour }}</span> call{{ calls_per_hour > 1 ? 's' : '' }} per hour</p>
          </div>
      </v-card-text>
    </v-card>
</template>

<script>
import BarChart from './barchart'

export default {
  name: 'dash_calldist',
  components: {
    barchart: BarChart
  },
  props: {
    hourstats: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    chartdata: null,
    chartoptions: {
      legend: {
        display: false
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              fontColor: "#ffffff"
            },
            gridLines: {
              display: true
            }
          }
        ],
        xAxes: [
          {
            ticks: {
              fontColor: "#ffffff"
            },
            gridLines: {
              display: false
            },
            barPercentage: 0.7
          }
        ]
      },
      layout: {
        padding: {
          left: 5,
          right: 5,
          top: 15,
          bottom: 5
        }
      },
      maintainAspectRatio: false,
      responsive: true
    },
    loaded: false
  }),
  methods: {
    setData: function () {
      let min = 8
      let max = 16
      Object.keys(this.hourstats).forEach((k) => {
        let nk = Number(k)
        if (nk < min && nk > -1) {
          min = nk
        }
        if (nk > max && nk < 24) {
          max = nk
        }
      })
      let new_labels = []
      for (var h = min; h <= max; h++) {
        new_labels.push(h)
      }
      //this.$set(this.chartdata,'labels',new_labels)

      let new_data = []
      for (var h = min; h <= max; h++) {
        let hval = 0
        if (h in this.hourstats) {
          hval = this.hourstats[h]
        }
        new_data.push(hval)
      }

      this.chartdata = {
        labels: new_labels,
        datasets: [
          {
            label: 'Channels',
            backgroundColor: '#f87979',
            data: new_data
          }
        ]
      }

      this.loaded = true
    }
  },
  computed: {
    calls_per_hour: function () {
      let total = 0
      let min = 8
      let max = 16
      Object.keys(this.hourstats).forEach((k) => {
        cnt++
        if (k < min && k > -1) {
          min = k
        }
        if (k > max && k < 24) {
          max = k
        }
        total += Number(this.hourstats[k])
      })
      let cnt = max - min + 1
      if (cnt < 1) {
        return 0
      }
      return Math.round(total / cnt)
    }
  },
  watch: {
    hourstats: function () {
      this.setData()
    }
  },
  beforeMount: function() {
    this.setData()
  }
}
</script>

<style scoped>
.chartwrapper {
  max-width: 300px;
}
</style>
